module.exports = __webpack_public_path__ + "static/inconsolata-latin-700.f4976aac.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-inconsolata/files/inconsolata-latin-700.woff2
// module id = ./node_modules/typeface-inconsolata/files/inconsolata-latin-700.woff2
// module chunks = 17241999800008180000